import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetEmailerListRequest, State } from './types';
import * as thunks from './thunks';

const initialState: State = {
  meta: {},
  filters: {},
  emailerList: [],
  isLoading: false,
  emailerDetails: {}
};

const slice = createSlice({
  name: 'emailer',
  initialState,
  reducers: {
    setFilters(state, { payload }: PayloadAction<GetEmailerListRequest>) {
      state.filters = { ...state.filters, ...payload };
    }
  },
  extraReducers(builder) {
    // get list
    builder.addCase(thunks.getEmailerListThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(thunks.getEmailerListThunk.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(
      thunks.getEmailerListThunk.fulfilled,
      (state, { payload }) => {
        state.emailerList = payload?.originalData?.data || [];
        state.meta = payload?.originalData?.meta || {};
        state.isLoading = false;
      }
    );

    // get details
    builder.addCase(thunks.getEmailerDetailsThunk.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(thunks.getEmailerDetailsThunk.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(
      thunks.getEmailerDetailsThunk.fulfilled,
      (state, { payload }) => {
        state.emailerDetails = payload?.originalData?.data || {};
        state.isLoading = false;
      }
    );
  }
});

export const reducer = slice.reducer;
export const actions = { ...slice?.actions, ...thunks };
